import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { format } from 'date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

type MyDatum = { date: Date; count: number };

type IProps = {
  data: MyDatum[];
  title?: string;
  toolTipTitle?: string;
};

export function CustomAreaChart({
  data,
  title = 'chart',
  toolTipTitle = 'orders',
}: IProps) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
  };

  const labels = data.map((c: MyDatum) => format(new Date(c.date), 'yy-MM-dd'));

  const chartData = {
    labels,
    datasets: [
      {
        fill: true,
        label: toolTipTitle,
        data: data.map((c: MyDatum) => c.count),
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };

  return <Line options={options} data={chartData} />;
}
